import type { RawKaiCoachSection } from './kaiCoachTypes';

function asRecord(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : null;
}

/**
 * Return the Kai Coach section carried by a course component, if any. A component
 * is a Kai Coach when one of its sections has `kai_coach_section` set — mirroring
 * how the other section variants (content/question/video) are detected. Accepts
 * any component-shaped value so it works for both the homepage and content
 * `RawComponent` types without coupling to either.
 */
export function getKaiCoachSection(component: unknown): RawKaiCoachSection | null {
  const sections = asRecord(component)?.sections;
  if (!Array.isArray(sections)) {
    return null;
  }
  for (const section of sections) {
    const record = asRecord(section);
    const coach = record?.kai_coach_section ?? record?.kaiCoachSection;
    if (coach) {
      return coach as RawKaiCoachSection;
    }
  }
  return null;
}

/** Whether a course component is a Kai Coach module. */
export function isKaiCoachComponent(component: unknown): boolean {
  return getKaiCoachSection(component) !== null;
}
